export const CREDIT_GROUP = 'Grupal';
export const CREDIT_PERSONAL = 'Individual';
export const CREDIT_EMPLOYEE = 'Empleado';